import { useReport } from './hooks/use-context';

export function LocationRef() {
  const { body } = useReport();

  const { location_ref } = body;

  return (
    <div style={{ marginBottom: '8px' }}>
      <div
        style={{
          width: '100%',
          backgroundColor: '#d3d3d3',
          textAlign: 'center',
          padding: '4px',
          fontWeight: 'bold',
          border: '1px solid black',
          borderBottom: 'none',
        }}
      >
        REFERÊNCIA DE LOCALIZAÇÃO
      </div>
      <div
        style={{
          width: '100%',
          backgroundColor: '#ffffcc',
          textAlign: 'center',
          padding: '8px',
          border: '1px solid black',
        }}
      >
        {location_ref?.answers?.[0]?.content || '-'}
      </div>
    </div>
  );
}
